<template src="./paladin-property-preset-item.html"></template>

<script>

import _ from 'lodash'

export default {
  name: 'PaladinPropertyPresetItem',
  components: { },
  props: {
    preset: {
      type: Object,
      required: true,
      default: function() {  return {} },
    },
  },
  data() {
    return {
      value: null,
      optionValue: null,
      isLoading: true,
    }
  },
  computed: {
  },
  watch: {
    preset: function() {
      this.init()
    },
    value: {
      deep: true,
      handler(){
      if(!this.isLoading) this.$emit('update', this.value)
    }}
  },
   created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {
      this.value = _.clone(this.preset, true)
      this.isLoading = false
    },
    removeOption(container, option)
    {
      var match = container.options.find(function(element) {
        return element === option
      });

      if(match)
      {
        container.options.splice(container.options.indexOf(match), 1)
      }
    },
    addOption(container, option)
    {
      if(!container.options) container.options = []

      container.options.push(option)
    },
    remove()
    {
      this.$emit('remove', this.value)
    },
  },
}
</script>

<style lang="scss"></style>
